import { atom, useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { ATOM_KEY } from "../keys";

const bookingCheck = atom<any>({
    default: undefined,
    key: ATOM_KEY.BOOKING_CHECK,
});

export const useBookingCheckValue = () => useRecoilValue(bookingCheck);
export const useBookingCheckState = () => useRecoilState(bookingCheck);
export const useSetBookingCheckState = () => useSetRecoilState(bookingCheck);
